// This file was automatically generated from uiwidget.ClickItem.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.ClickItem');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.ClickItem.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class=""><div class="ci-section el8FieldSection"><textarea class="ci-edit el8ClickItemField" spellcheck="', soy.$$escapeHtml(opt_data.spellcheck), '"', (opt_data.maxLength) ? ' maxlength="' + soy.$$escapeHtml(opt_data.maxLength) + '"' : '', (opt_data.name) ? ' name="' + soy.$$escapeHtml(opt_data.name) + '"' : '', '></textarea></div><div class="ci-display el8ClickItemDisplay"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.ClickItem.removeTrigger = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<a class="ci-remove-trigger el8RemoveAttachmentButton"></a>');
  if (!opt_sb) return output.toString();
};
